import styled from 'styled-components';

import { BLACK, PAGE_WIDTH, WHITE } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const STEP_COLOR = '#d7d7d7';
export const HAIR_CARE = 'HAIR_CARE';
export const SCALP_CARE = 'SCALP_CARE';
export const HAIR_AND_SCALP_CARE = 'HAIR_AND_SCALP_CARE';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-direction: column;
  max-width: ${PAGE_WIDTH}px;
  min-height: 100vh;
  margin: 0 auto 0;
  // background: linear-gradient(90deg, #a7b9c7 -40%, white, #a7b9c7 140%);
`;
export const ContentContainer = styled.div`
  flex: 1;
  flex-wrap: wrap;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  margin: 85px auto 0;
  ${media.tabletP`
    margin: 150px auto 0;
  `};
`;
export const TitleText = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: ${BLACK};
  margin-bottom: 10px;
  padding: 0 20px;
  ${media.tabletP`
    font-size: 30px;
    padding: 0;
  `};
`;
export const DescriptionText = styled.div`
  align-items: center;
  color: ${BLACK};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 35px;
  text-align: center;
  justify-content: center;
  padding: 0 50px;
  ${media.tabletP`
  font-size: 18px;
    padding: 0;
    text-align: unset;
  `};
`;

export const ProgramListContainer = styled.div`
  flex: 1;
  flex-wrap: wrap;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px 24px 20px;
  margin: 0 auto;
  ${media.tabletP`
    width: 728px;
    padding: 0;
    margin: 0 auto 100px;
  `};
`;
export const ProgramRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  position: relative;
  margin-bottom: 10px;
  padding: 20px 20px 30px 20px;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.15);
  ${media.tabletP`
    flex-direction: row;
  `};
`;
export const ProgramImage = styled.div`
  width: 118px;
  height: 88px;
  margin-right: 10px;
  ${media.tabletP`
    margin-right: 42px;
    height: 180px;
    width: 240px;
  `};
`;
export const ProgramContent = styled.div`
  flex: 1;
  flex-grow: 1;
`;
export const ProgramContentColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: ${({ hasPromotionText }) => (hasPromotionText ? '0px' : '22px')};
`;
export const ProgramContentRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  margin-top: 25px;
`;

export const ProgramTitle = styled.div`
  font-size: 16px;
  color: ${BLACK};
  margin-top: ${({ hasPromotionText }) => (hasPromotionText ? '5px' : '10px')};
  margin-bottom: 6px;
  ${media.tabletP`
    width: 300px;
    font-size: 22px;
    margin-top: 0px;
  `};
`;
export const ProgramName = styled.div`
  font-size: 12px;
  color: #888888;
  ${media.tabletP`
    margin-bottom: 30px;
  `};
`;

export const PowerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-bottom: 10px;
  ${media.tabletP`
    padding-right: 50px;
    margin-bottom: 5px;
    flex-direction: row;
  `};
`;
export const PowerTitle = styled.div`
  font-size: 12px;
  color: ${BLACK};
  width: 100px;
  margin: 10px 0 5px 0;
  ${media.tabletP`
    font-size: 14px;
    margin: 0;
  `};
`;
export const PowerValueContainer = styled.div`
  flex: 1;
  flex-grow: 1;
  overflow: hidden;
  width: 100%;
  .powerbar {
    margin-left: 0px;
    width: 125%;
    margin-top: 3px;
    display: flex;
  }
  .powerbar li {
    list-style-type: none;
    width: 25%;
    min-width: calc(26.6666666667% - 3.3333333333px);
    /*float: left;*/
    font-size: 5px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: ${STEP_COLOR};
  }

  .powerbar li:before {
    width: 10px;
    height: 10px;
    content: '';
    line-height: 10px;
    background-color: ${STEP_COLOR};
    display: block;
    text-align: center;
    border-radius: 50%;
  }

  .powerbar li:after {
    width: 100%;
    height: 2px;
    content: '';
    position: absolute;
    background-color: ${STEP_COLOR};
    top: 4px;
    left: -100%;
    margin-left: 10px;
  }
  .powerbar li:first-child:after {
    content: none;
  }
  .powerbar li.active {
    color: ${({ color }) => color}
  }
  .powerbar li.active:before {
    background-color: ${({ color }) => color};
  }
  .powerbar li.active:after {
    background-color: ${({ color }) => color};
  }

  ${media.tabletP`
    .powerbar {
      width: 250px;
    }
    .powerbar li {
      width: 25%;
      min-width: initial;
    }
    .powerbar li:after {
      left: -50%;
      margin-left: 5px;
    }
    .powerbar li:before {
      margin: 0 auto 0 auto;
    }
  `};
`;
export const TimePriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;
  ${media.tabletP`
    padding-right: 50px;
  `};
`;
export const ProgramTime = styled.div`
  font-size: 12px;
  color: ${BLACK};
  padding-right: 15px;
`;
export const ProgramPrice = styled.div`
  font-size: 12px;
  color: ${BLACK};
`;

export const CareLabel = styled.div`
  min-height: 21px;
  background-color: ${({ color }) => color};
  border-radius: 14px;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 10px;
  color: ${WHITE};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 13px;
  padding: ${({ isTwoLines }) => (isTwoLines ? '3px 11px' : '3px 13px')};
  min-width: 50px;
  ${media.tabletP`
    font-size: 14px;
    width: 98px;
    min-height: 28px;
    right: 20px;
    top: 20px;

    ${({ isTwoLines }) =>
      isTwoLines &&
      `
      font-size: 12px;
      padding: 5px 13px;
      line-height: 13px;
      border-radius: 20px;
    `};
  `};
`;
export const PromotionLabel = styled.div`
  color: #d70303;
  font-size: 11px;
  ${media.tabletP`
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 8px;
  `};
`;
export const LabelText = styled.div`
  br {
    display: none;
  }
  ${media.tabletP`
    br {
      display: block;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SalonProgramPage/SalonProgramPage.style.js